module.exports = __webpack_public_path__ + "img/carshina22_13.f4aea522.jpg";